import React from 'react';

// icons
import IconDownload from '../../../assets/ic-download.svg';

// styles
import './chartExport.scss';

interface CharExportProps {
    onClick: () => void;
}

const ChartExport = (props: CharExportProps) => {
    return (
        <button className="chartexportbtn" onClick={props.onClick}>
            <IconDownload />
        </button>
    );
};

export default ChartExport;
